import { Box, Grid, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import { Table, Tag, Progress, Button, Tooltip } from "antd";
import { FiDownload } from "react-icons/fi";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  downloadCertificate,
  listCertificates,
  getUploadedParticipantsFiles,
  downloadParticipantsFile,
} from "../functions/getData";
import { InfoCircleOutlined } from "@ant-design/icons";
import { deleteCertificate } from "../functions/deleteData";
import ConfirmDeleteModal from "../components/modal/ConfirmDeleteModal";
import { useSnackbar } from "notistack";
import NewCertificateModal from "../components/modal/NewCertificateModal";
import { cancelAction } from "../functions/general";
import { generateNewCertificates } from "../functions/postData";
import { showNotification } from "../functions/snackbar";

const UploadedParticipantsFiles = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [onApprove, setOnApprove] = useState(false);
  const cancelApprove = () => cancelAction(setOnApprove);

  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15); // can also use per_page from backend
  const [totalItems, setTotalItems] = useState(0);
  const [onDelete, setOnDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // const handleDeleteRow = async (id) => {
  //   setLoading(true);
  //   deleteCertificate({ ids: [id] }).then((res) => {
  //     listData(currentPage);
  //     setOnDelete(false);
  //     showNotification("success", res.message, enqueueSnackbar, closeSnackbar);
  //   });
  // };

  const handleDownload = async (id) => {
    setLoading(true);
    downloadParticipantsFile(id).then((res) => {
      // const link = document.createElement("a");
      // link.href = res?.download_link;
      // link.download = "";
      // link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      setLoading(false);
    });
  };

  const columns = [
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          ID
        </span>
      ),
      dataIndex: "id",
      key: "id",
    },

    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          File Name
        </span>
      ),
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Total Records
        </span>
      ),
      dataIndex: "totalRecords",
      key: "totalRecords",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Created By
        </span>
      ),
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,

            backgroundClip: "padding-box",
          }}
        >
          Created At
        </span>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: (
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#144A94",
            cursor: "pointer",
            height: 61,
            backgroundClip: "padding-box",
          }}
        >
          Status
        </span>
      ),
      dataIndex: "status",
      width: 70,
      key: "status",
      render: (status, data) => {
        if (status !== "Pending") {
          return (
            <Grid
              alignItems={"center"}
              display={"flex"}
              gap={5}
              justifyContent={"space-between"}
            >
              <Tag
                color={
                  status === "active" || status === "Completed"
                    ? "green"
                    : "red"
                }
              >
                {status}
              </Tag>
              <FiDownload
                onClick={() => handleDownload(data?.id)}
                className="action-icons download-icon"
                style={{ cursor: "pointer", stroke: "#144A94" }}
              />
              {/* <DeleteIcon
                onClick={() => {
                  setSelectedId(data?.id);
                  setOnDelete(true);
                }}
                className="action-icons delete-icon"
                style={{ cursor: "pointer", fill: "#E83042" }}
              /> */}
            </Grid>
          );
        } else if (status === "Pending" || status === "Completed") {
          return (
            <Progress
              percent={data?.progress}
              strokeColor="#144A94"
              showInfo={false}
            />
          );
        }
      },
    },
  ];

  const formatData = (data) => {
    let formattedData;

    formattedData = data?.map((el) => {
      const specifications = el?.specifications;
      return {
        id: el?.id,
        fileName: el?.original_filename,
        totalRecords: el?.total_records,
        createdBy: el?.created_by,
        createdAt: el?.created_at,
        status: el?.status,
        progress: el?.progress,
      };
    });
    return formattedData;
  };

  const listData = (page) => {
    setLoading(true);
    getUploadedParticipantsFiles(page).then((res) => {
      const { current_page, total, per_page } = res?.meta || {};

      setData(formatData(res?.data));
      setPageSize(per_page || 10);
      setTotalItems(total || 0);
      setCurrentPage(current_page);
    });
    setLoading(false);
  };

  useEffect(() => {
    listData(1);
  }, []);

  useEffect(() => {
    console.log("reloaded", data);
    const interval = setInterval(() => {
      if (data.some((row) => row.status === "Pending")) {
        console.log(currentPage, "loaded");
        listData(currentPage);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [data]);

  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <div className="dashboardAndSelfBtnDiv">
          <ReusableButton
            text="Dashboard"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            width={125}
            br={18}
            to="/dashboard"
            iconType="home"
          />
          <ChevronRightIcon />
          <ReusableButton
            text="Uploaded Participants Files"
            fontSize={14}
            bgColor="#F16774"
            height={36}
            br={18}
            onClick={() => {}}
          />
        </div>
      </Grid>
      <Grid className="tableContainer" container flexDirection={"column"}>
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <NunitoText
            value="Uploaded Participants Files"
            fontSize={40}
            align={"left"}
            fontWeight={700}
            marginBottom={40}
            italic
            color="#144A94"
          />
          {/* <ReusableButton
            marginBottom={40}
            text="Add Print"
            fontSize={15}
            bgColor="#5E75C3"
            height={46}
            marginRight={20}
            iconType="add"
            onClick={() => setOnApprove(true)}
          /> */}
        </Grid>
        <Table
          columns={columns}
          dataSource={data}
          showSorterTooltip={false}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,

            onChange: (page, pageSize) => {
              listData(page, pageSize);
            },
          }}
        />
      </Grid>
      {/* <Modal open={onDelete} onClose={() => setOnDelete(false)}>
        <>
          <ConfirmDeleteModal
            cancelDelete={() => setOnDelete(false)}
            deleteFunction={handleDeleteRow}
            id={selectedId}
            objectName={"this Print"}
          />
        </>
      </Modal> */}
    </Box>
  );
};

export default UploadedParticipantsFiles;
